import { useEffect, useState } from 'react';

/**
 * useIsDark — live read of the class-based theme (`html.dark`, see
 * src/index.css `@custom-variant dark`). Follows toggles via a MutationObserver
 * on the root class attribute, the same technique HeroBackground and
 * MermaidDiagram already use for canvas/SVG rendering.
 */
export const useIsDark = (): boolean => {
  const [isDark, setIsDark] = useState<boolean>(() =>
    typeof document !== 'undefined'
      ? document.documentElement.classList.contains('dark')
      : true,
  );

  useEffect(() => {
    const root = document.documentElement;
    const observer = new MutationObserver(() => {
      setIsDark(root.classList.contains('dark'));
    });
    observer.observe(root, { attributes: true, attributeFilter: ['class'] });
    return () => observer.disconnect();
  }, []);

  return isDark;
};
